import '../../startup/public-path';
import '../g2/styles/main.less';
import app from '../../startup/app';
import hydrateApp from './hydrate-app';

app(hydrateApp);
